import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowRight } from "lucide-react";
import Section from "@/components/Section";
import Reveal from "@/components/Reveal";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/i18n/useLanguage";
import teamCollaboration from "@/assets/team-collaboration.png";

const AboutTeaser = () => {
  const { t } = useTranslation();
  const { localize } = useLanguage();

  return (
    <Section containerSize="wide">
      <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center">
        <Reveal className="order-2 md:order-1 flex flex-col items-center text-center">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-4">
            {t("homeAbout.titlePre")}{" "}
            <span>{t("homeAbout.titleAccent")}</span>
          </h2>
          <div className="h-1 w-16 rounded-full bg-gradient-brand mb-5" />
          <Button variant="primary" size="lg" asChild>
            <Link to={localize("/about")} className="inline-flex items-center gap-2">
              {t("homeAbout.cta")}
              <ArrowRight className="w-4 h-4" />
            </Link>
          </Button>
        </Reveal>

        <Reveal className="order-1 md:order-2" delay={120}>
          <div className="relative">
            <div className="absolute -inset-2 bg-gradient-brand opacity-20 blur-2xl rounded-2xl" aria-hidden />
            <img
              src={teamCollaboration}
              alt={t("aboutStory.s1.imageAlt")}
              className="relative w-full h-auto object-cover rounded-2xl border border-border/60"
              loading="lazy"
            />
          </div>
        </Reveal>
      </div>
    </Section>
  );
};

export default AboutTeaser;
